import type { Breadcrumb, BreadcrumbHint } from '@sentry/vue';

export const sentryBreadcrumbEnhancement = (
  breadcrumb: Breadcrumb,
  hint?: BreadcrumbHint,
): Breadcrumb => {
  if (breadcrumb.category === 'ui.click' && hint) {
    const clickTarget: HTMLElement | undefined = hint.event?.target;
    let messagePrefix;
    try {
      if (hint.event !== undefined && clickTarget !== undefined) {
        const labelContainer = clickTarget.closest('div[data-v]');
        if (labelContainer !== null) {
          messagePrefix = (labelContainer as HTMLDivElement).dataset.v;
          // avoid infos on app container
        } else if (!clickTarget.classList.contains('min-h-screen')) {
          const { innerText } = clickTarget;

          // avoid useless information like clicking on random container
          if (innerText.length < 30) {
            messagePrefix = innerText;
          }
        }

        if (messagePrefix !== undefined) {
          breadcrumb.message = `${messagePrefix} | ${breadcrumb.message ?? ''}`;
        }
      }
    } catch (e) {
      // avoid blocking the sentry reporting
    }
  }

  return breadcrumb;
};
